<template>
    <div>
        <div class="wrapper">
            <div class="animated fadeIn">
                <b-row>
                    <b-col cols="12" class="mb-3">
                        <b-button variant="primary" @click="$router.push('/admin/chili-templates/toevoegen')" class="pull-right">Chili Template toevoegen</b-button>
                    </b-col>
                </b-row>
                <resource-index header="Chili Templates" endpoint="chili-templates" show-route="chili-templates.view"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ResourceIndex from '../../components/ResourceIndex';

    export default {
        name: 'chili-templates',
        components: {ResourceIndex},
        computed: {
            userRole () {
                return this.$store.state.userRole
            }
        },
    }
</script>
